import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import { EntitiesListContext } from "./EntitiesListContext";

export const useEntitiesListProvider = () => {
  const context = useContext(EntitiesListContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useEntitiesListProvider",
      "EntitiesListContext"
    );
  }

  return context;
};
